import { Persistore } from 'persistore';
import { _ } from '@hugendubel/utils';
import { Token, WsClient } from '@hugendubel/ws_client';
import { Track, TRACK_ID } from '@hugendubel/tracking_manager';
import { AuthService } from '@hugendubel/login';
import { ClientNavigation, Modal } from '@hugendubel/react-basic';
import { initialState, Store } from './store';
import { TempSessionForFamily } from './temp-session';
import * as Intl from 'first-intl';
import intlData from './intl-de.json';

// We have check for and start the temporary TokenStore session, if the scope is family, before we configure the packages!
TempSessionForFamily.start();

const onUpdate = (authenticated: boolean, wsToken?: Token): void => {
    Store.set({ wsToken: wsToken || null });
};
const cleanUpFromAuth = (): void => {
    Modal.close();
    Store.set(initialState);
};
const cleanUpNoAuth = (): void => {};

export const configurePackages = (): void => {
    ClientNavigation.configure({ outerFrameAccessAllowed: true });
    _.configure({ onError: (desc: string) => Track.error(TRACK_ID('2019-10-21 01:51:53'), desc) });
    AuthService.configure({
        onUpdate,
        cleanUpNoAuth,
        cleanUpFromAuth,
    });
    WsClient.init({
        onLogout: AuthService.onWsClientLogout,
        onUpdate: AuthService.onWsClientUpdate,
        cred: {
            username: process.env.IS_HUDU ? 'Hudu-Mobile-Shop-Vollsortiment' : 'Mobile-Shop-Vollsortiment',
        },
    });
    Track.WS.configure({
        appName: 'customer',
        loginAccessor: AuthService.isLoggedIn,
        prod: process.env.NODE_ENV !== 'development',
    });
    Intl.configure({ tracker: (desc: string) => Track.error(TRACK_ID('2020-11-11 05:38:00'), desc) });
    Intl.addIntlData(intlData);
    Persistore.config({ insecure: process.env.NODE_ENV === 'development' });
};

configurePackages();
